const Grn = () => import("./views/grn.vue");

import DashboardLayout from "../../../views/Layout/DashboardLayout.vue";

const moduleRoute = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/grn",
      component: Grn,
      name: "GRN",
      meta: {
        groupName: "GRN",
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
